//TopNavBar

import React from 'react'
import './TopNavBar.css'
import { BrowserRouter } from 'react-router-dom';
export interface TopNavBarProps {
    trialExpired?: boolean;
    children?: React.ReactNode;
}

const TopNavBar: React.FC<TopNavBarProps> = ({
    trialExpired,
    children
}): JSX.Element => {
    return (
        <nav className='TopNavbar'>
            <div className={`TopNavbar__content ${trialExpired ? 'trialLogo' : 'logo'} flex-v-center`}>
                {children}
            </div>
        </nav>
    )
}

export default TopNavBar;